// Shared option lists and formatters for the Campus Ministry forms and admin screens.

export const FORM_TYPE_LABELS = {
  'fall-retreat': 'Fall Retreat'
};

export const STUDENT_CATEGORY_LABELS = {
  'rowan-undergrad': 'Rowan University undergraduate',
  'other': 'All other students'
};

export const PAYMENT_STATUS_LABELS = {
  paid: 'Paid',
  open: 'Balance Due',
  hardship: 'Hardship'
};

export const PAYMENT_STATUS_COLORS = {
  paid: 'success',
  open: 'warning',
  hardship: 'info'
};

export const priceForCategory = (event, category) => {
  if (!event?.pricing) return 0;
  if (category === 'rowan-undergrad') return Number(event.pricing.rowanUndergrad) || 0;
  if (category === 'other') return Number(event.pricing.otherStudents) || 0;
  return 0;
};

export const formatCurrency = (n) =>
  (Number(n) || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// Dates of birth are stored as UTC midnight; show them without a timezone shift.
export const formatDateOnly = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toLocaleDateString('en-US', { timeZone: 'UTC' });
  } catch {
    return '';
  }
};

export const formatDateTime = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toLocaleString('en-US', { timeZone: 'America/New_York' });
  } catch {
    return '';
  }
};

export const totalPaid = (registration) =>
  (registration?.payment?.transactions || []).reduce((sum, t) => sum + (Number(t.amount) || 0), 0);

export const balanceDue = (registration) =>
  Math.max(0, Math.round(((registration?.payment?.amount || 0) - totalPaid(registration)) * 100) / 100);

export const fullName = (registration) =>
  [registration?.firstName, registration?.lastName].filter(Boolean).join(' ');

// Loads the Square Web Payments SDK and attaches a card form to `containerId`.
// Same behavior as the OCIA/RE pages: production SDK on stbridgetup.org, sandbox elsewhere.
export const attachSquareCard = async (axios, containerId) => {
  const configRes = await axios.get('/square-config');
  const { applicationId, locationId } = configRes.data || {};
  if (!applicationId || !locationId) throw new Error('Square configuration is incomplete.');

  const isProd = window.location.hostname.includes('stbridgetup.org');
  const sdkUrl = isProd
    ? 'https://web.squarecdn.com/v1/square.js'
    : 'https://sandbox.web.squarecdn.com/v1/square.js';

  await new Promise((resolve, reject) => {
    if (window.Square) return resolve();
    const existing = document.querySelector(`script[src="${sdkUrl}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.src = sdkUrl;
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });

  const payments = window.Square.payments(applicationId, locationId);
  const card = await payments.card();
  await card.attach(`#${containerId}`);
  return card;
};

export const newIdempotencyKey = () => (window.crypto?.randomUUID
  ? window.crypto.randomUUID()
  : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
